// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + "ea94f15158e2b36d7c4f" + ".css";
};